import styled, { css } from 'styled-components/macro';

export const TextareaDiv = styled.div`
  margin: 2rem 0;
  position: relative;
  ${props =>
    props.meta.touched &&
    props.meta.error &&
    css`
      color: ${props => props.theme.red};
    `}
  label {
    padding: 12px 0 6px;
    display: inline-block;
  }
`;

export const Textarea = styled.textarea`
  ${props => props.theme.fontStackBody}
  outline: none;
  resize: none;
  width: 100%;
  height: 10rem;
  font-size: 1.3rem;
  line-height: 1.7rem;
  border: ${props => props.theme.defaultBorder};
  margin-top: 0.5rem;

  ${props =>
    props.meta.touched &&
    props.meta.error &&
    css`
      border-color: ${props => props.theme.red};
    `}
`;
